import styled from "styled-components";

const UnstyledButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  align-items: center;
  justify-content: center;
`;

export default UnstyledButton;
